import { render, staticRenderFns } from "./dataAnalysis.vue?vue&type=template&id=22a4941f&scoped=true&"
import script from "./dataAnalysis.vue?vue&type=script&lang=js&"
export * from "./dataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysis.vue?vue&type=style&index=0&id=22a4941f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a4941f",
  null
  
)

export default component.exports